export default __webpack_public_path__ + "static/media/noVip.16720a86.svg";